// UI types for custom component rendering

// Re-export LoadExternalComponent
export { LoadExternalComponent } from "../components/ui/LoadExternalComponent";

export interface UIMessage {
  id: string;
  type: "ui";
  component: string;
  props?: Record<string, any>;
  metadata?: Record<string, any>;
}

export interface RemoveUIMessage {
  id: string;
  type: "remove_ui";
}

export type UIMessageAction = UIMessage | RemoveUIMessage;

// Type guard functions
export function isUIMessage(obj: any): obj is UIMessage {
  return obj && typeof obj === "object" && obj.type === "ui";
}

export function isRemoveUIMessage(obj: any): obj is RemoveUIMessage {
  return obj && typeof obj === "object" && obj.type === "remove_ui";
}

// UI Message Reducer
export function uiMessageReducer(
  state: UIMessage[],
  action: UIMessageAction,
): UIMessage[] {
  if (isRemoveUIMessage(action)) {
    return state.filter((msg) => msg.id !== action.id);
  }

  if (isUIMessage(action)) {
    const existingIndex = state.findIndex((msg) => msg.id === action.id);
    if (existingIndex >= 0) {
      // Replace existing message
      const newState = [...state];
      newState[existingIndex] = action;
      return newState;
    } else {
      // Add new message
      return [...state, action];
    }
  }

  return state;
}
